import { Stack } from '@contrast-security-inc/design-system-layouts'
import { DiagnosticCollectionLogLevelInput } from './log-level-input'
import { Box } from '../../../legacy-design-system/form'
import React from 'react'
import {
  DiagnosticCollectionFormValue,
  DiagnosticCollectionSetterFactory
} from '../index'
import { DiagnosticCollectionDurationInput } from './diagnostic-collection-duration-input'
import { useIntl } from 'react-intl'

export function DiagnosticCollectionEnableForm({
  formValue,
  formSetter,
  isReadOnly
}: {
  formValue: DiagnosticCollectionFormValue
  formSetter: DiagnosticCollectionSetterFactory
  isReadOnly?: boolean
}) {
  const { formatMessage } = useIntl()
  return (
    <Box>
      <Stack alignItems="center" flexDirection="row">
        <DiagnosticCollectionLogLevelInput
          value={formValue.logLevel}
          onChange={formSetter('logLevel')}
          isReadOnly={isReadOnly}
        />
        {formatMessage({
          id: 'detail_servers_send_logs'
        })}
        <DiagnosticCollectionDurationInput
          value={formValue.duration}
          onChange={formSetter('duration')}
          isReadOnly={isReadOnly}
        />
        {formatMessage({
          id: 'detail_servers_send_logs_hours'
        })}
      </Stack>
    </Box>
  )
}
